<div class="tnode">
  <div class="tnode__row">
    @if (no().socios.length) {
      <button
        type="button"
        class="tnode__caret"
        [attr.aria-expanded]="expandido()"
        [attr.aria-label]="expandido() ? 'Recolher' : 'Expandir'"
        (click)="alternar()">
        {{ expandido() ? '▼' : '▶' }}
      </button>
    } @else {
      <span class="tnode__caret tnode__caret--none" aria-hidden="true"></span>
    }
    <span class="tnode__company">{{ no().nome }}</span>
    <span class="tnode__doc">{{ no().cnpj | vaultMaskCnpj }}</span>
    <span class="tnode__count">{{ no().n_socios }} sócios</span>
    @if (stub) {
      <span class="tnode__muted">já exibida acima</span>
    }
  </div>

  @if (expandido()) {
    <ul class="tnode__children">
      @for (s of no().socios; track $index; let i = $index) {
        <li>
          <div class="tnode__row">
            @if (s.empresas.length) {
              <button
                type="button"
                class="tnode__caret"
                [attr.aria-expanded]="sociosAbertos().has(i)"
                [attr.aria-label]="sociosAbertos().has(i) ? 'Recolher' : 'Expandir'"
                (click)="alternarSocio(i)">
                {{ sociosAbertos().has(i) ? '▼' : '▶' }}
              </button>
            } @else {
              <!-- Como no Dossiê: sócio sem empresas no recorte não tem seta, só o recuo. -->
              <span class="tnode__caret tnode__caret--none" aria-hidden="true"></span>
            }
            <span class="tnode__partner">{{ s.nome }}</span>
            <span
              class="badge"
              [class.badge--pf]="s.tipo === 'PF'"
              [class.badge--pj]="s.tipo === 'PJ'"
              >{{ s.tipo }}</span
            >
            @if (s.qualificacao) {
              <span class="tnode__muted">{{ s.qualificacao }}</span>
            }
          </div>
          @if (sociosAbertos().has(i)) {
            <div class="tnode__nested">
              @for (e of s.empresas; track e.cnpj + '-' + $index) {
                <app-registry-tree-node [no]="e" />
              }
            </div>
          }
        </li>
      }
    </ul>
  }
</div>
